export default __webpack_public_path__ + "static/media/prev-GNSS-Receiver-5.0a446d14.png";